<template>
  <div>
    <div v-if="$store.state.step === 1" class="text-center">
      <h4>Edit Headshot</h4>
      <img class="mt-4" v-if="this.headshot" :src="this.headshotThumb" />
      <img
        class="mt-4"
        v-else
        :src="this.no_headshot"
        width="100"
        height="100"
      />
      <br />
      <b-button
        type="button"
        variant="outline-primary"
        class="mt-4 rounded-pill"
        id="upload"
        @click.prevent="uploadFile()"
        >UPLOAD HEADSHOT</b-button
      >
      <br />
      <br />
    </div>
    <FileUpload />
  </div>
</template>
<script>
import FileUpload from "./FileUpload";
export default {
  name: "StepOne",
  props: ["step"],
  mounted() {},
  data: function() {
    return {
      no_headshot: "https://i.imgur.com/Gcvs580m.png",
    };
  },
  methods: {
    next() {
      this.$store.commit("changeStep", 2);
    },
    setStep(newStep) {
      this.$store.commit("changeStep", newStep);
    },
    uploadFile: function() {
      this.$bvModal.show("file-upload");
      console.log("open file-upload");
    },
  },
  components: {
    FileUpload,
  },
  computed: {
    headshot: {
      get() {
        return this.$store.state.customization.headshot;
      },
    },
    headshotThumb: {
      get() {
        return "https://drive.google.com/thumbnail?id=" + this.headshot;
      },
    },
  },
};
</script>
